module.exports = __webpack_public_path__ + "media/images/introduce_3-037f18abb8bc080bb3b1ba3039c62ee6.jpg";